import React from 'react'
import PropTypes from 'prop-types'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import myLibrarySchoolJoinConfirmSelector from 'redux/selectors/my_library/my_library_school_join_confirm_selector'
import { localize, localizeWithVars } from 'helpers/translator/localize'

const MyLibrarySchoolJoinConfirm = props => (
	<Confirm
		alertTitle={localizeWithVars('login_notification_school_join_title', { SchoolName: props.schoolName })}
		btTwo={localize('thanks')}
		alertMessage={props.hasDistrictProduct ? localize('login_notification_district_join_message_2') : localize('login_notification_school_join_message_2')}
		actionTwo={props.actions.closeSchoolJoinConfirm}
		closeAction={props.actions.closeSchoolJoinConfirm}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeSchoolJoinConfirm: myLibraryActions.closeSchoolJoinConfirm,
	}, dispatch)
}

function mapStateToProps(state) {
	return myLibrarySchoolJoinConfirmSelector(state)
}

MyLibrarySchoolJoinConfirm.defaultProps = {
	hasDistrictProduct: false,
}

MyLibrarySchoolJoinConfirm.propTypes = {
	schoolName: PropTypes.string.isRequired,
	hasDistrictProduct: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(MyLibrarySchoolJoinConfirm)

export { MyLibrarySchoolJoinConfirm }
